//Numeros
export const numVentasPrincipal = "573161585420";
export const numVentasSecundario = "573132021604";

export const portalClientes = "https://portalcliente.dufyasesorias.com/";
export const portalTutores = "https://tutor.dufyasesorias.com/";

//links
export const instagram = "https://www.instagram.com/dufyasesorias/";
export const facebook = "https://www.facebook.com/dufyasesoriasoficial/";
export const youtube = "https://www.youtube.com/@dufyasesorias9395";
export const tikotk = "https://www.tiktok.com/@dufyasesorias";

export const logo = "https://dufyasesorias.com/wp-content/uploads/2026/06/DUFYBLANCO-1.jpg";
export const logoFooter = "https://dufyasesorias.com/wp-content/uploads/2026/06/dufyxd-1.jpg";